// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"528":"e4a0df4d","656":"18570a21","899":"18570a21"}[chunkId] + ".chunk.css";
};